<template>
  <div>
    <!-- <b-form>
      <div class="row mb-3">
        <div class="col-md-6 mb-3">
          <label for="provinsi">Provinsi</label>
          <v-select
            id="provinsi"
            v-model="form.provinsi_perubahan"
            :reduce="(data) => data.nama_provinsi"
            label="nama_provinsi"
            :options="dataProvinsi"
            name="Provinsi"
            style="opacity: 0.7"
            disabled
          />
        </div>
        <div class="col-md-6 mb-3">
          <label for="kabupaten">Kabupaten</label>
          <v-select
            id="kabupaten"
            v-model="form.kabupaten_perubahan"
            :reduce="(data) => data.nama_kabupaten"
            label="nama_kabupaten"
            :options="dataKabupaten"
            name="Kabupaten"
            style="opacity: 0.7"
            disabled
          />
        </div>
        <div class="col-md-6 mb-3">
          <label for="kecamatan">Kecamatan</label>
          <v-select
            id="kecamatan"
            v-model="form.kecamatan_perubahan"
            :reduce="(data) => data.nama_kecamatan"
            label="nama_kecamatan"
            :options="dataKecamatan"
            name="Kecamatan"
            style="opacity: 0.7"
            disabled
          />
        </div>
        <div class="col-md-6 mb-3">
          <label for="nama_perairan">Nama Perairan</label>
          <b-form-input
            id="nama_perairan"
            v-model="form.nama_perairan_perubahan"
            name="Nama Perairan"
            style="opacity: 0.7"
            disabled
          ></b-form-input>
        </div>
        <div class="col-md-6 mb-3">
          <label for="garis_pantai">Garis Pantai</label>
          <b-form-input
            id="garis_pantai"
            v-model="form.garis_pantai_perubahan"
            name="Garis Pantai"
            style="opacity: 0.7"
            disabled
          ></b-form-input>
        </div>
        <div class="col-md-6 mb-3">
          <label for="kedalaman">Kedalaman (m)</label>
          <b-form-input
            id="kedalaman"
            v-model="form.kedalaman_perubahan"
            name="Kedalaman"
            type="number"
            style="opacity: 0.7"
            disabled
          ></b-form-input>
        </div>
        <div class="col-md-6 mb-3">
          <label for="jenis_permohonan">Jenis Permohonan</label>
          <v-select
            id="jenis_permohonan"
            v-model="form.jenis_pnbp_perubahan"
            :options="[
              'Area',
              'Kabel Bawah Laut',
              'Pipa Air Bersih / Air Baku',
              'Pipa Selain Air Bersih / Air Baku',
            ]"
            name="Jenis Permohonan"
            multiple
            style="opacity: 0.7"
            disabled
          />
        </div>
        <div
          v-if="form.jenis_pnbp_perubahan.includes('Area')"
          class="col-md-6 mb-3"
        >
          <label for="luas">Luas (ha)</label>
          <b-form-input
            id="luas"
            v-model="form.luas_perubahan"
            name="Luas"
            type="number"
            style="opacity: 0.7"
            disabled
          ></b-form-input>
        </div>
        <div
          v-if="form.jenis_pnbp_perubahan.includes('Kabel Bawah Laut')"
          class="col-md-6 mb-3"
        >
          <label for="panjang_konservasi_kabel">
            Panjang Kabel (di dalam Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_konservasi_kabel"
            v-model="form.panjang_konservasi_kabel_perubahan"
            name="Panjang Kabel (Dalam Kawasan)"
            type="number"
            style="opacity: 0.7"
            disabled
          ></b-form-input>
        </div>
        <div
          v-if="form.jenis_pnbp_perubahan.includes('Kabel Bawah Laut')"
          class="col-md-6 mb-3"
        >
          <label for="panjang_nonkonservasi_kabel">
            Panjang Kabel (di luar Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_nonkonservasi_kabel"
            v-model="form.panjang_nonkonservasi_kabel_perubahan"
            name="Panjang Kabel (Luar Kawasan)"
            type="number"
            style="opacity: 0.7"
            disabled
          ></b-form-input>
        </div>
        <div
          v-if="
            form.jenis_pnbp_perubahan.includes('Pipa Air Bersih / Air Baku')
          "
          class="col-md-6 mb-3"
        >
          <label for="panjang_konservasi_pipa_air">
            Panjang Pipa Air Bersih (di dalam Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_konservasi_pipa_air"
            v-model="form.panjang_konservasi_pipa_air_perubahan"
            name="Panjang Pipa (Dalam Kawasan)"
            type="number"
            style="opacity: 0.7"
            disabled
          ></b-form-input>
        </div>
        <div
          v-if="
            form.jenis_pnbp_perubahan.includes('Pipa Air Bersih / Air Baku')
          "
          class="col-md-6 mb-3"
        >
          <label for="panjang_nonkonservasi_pipa_air">
            Panjang Pipa Air Bersih (di luar Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_nonkonservasi_pipa_air"
            v-model="form.panjang_nonkonservasi_pipa_air_perubahan"
            name="Panjang Pipa (Luar Kawasan)"
            type="number"
            style="opacity: 0.7"
            disabled
          ></b-form-input>
        </div>
        <div
          v-if="
            form.jenis_pnbp_perubahan.includes(
              'Pipa Selain Air Bersih / Air Baku',
            )
          "
          class="col-md-6 mb-3"
        >
          <label for="panjang_konservasi_pipa_lain">
            Panjang Pipa Selain Air Bersih (di dalam Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_konservasi_pipa_lain"
            v-model="form.panjang_konservasi_pipa_lain_perubahan"
            name="Panjang Pipa Selain Air Bersih (Dalam Kawasan)"
            type="number"
            style="opacity: 0.7"
            disabled
          ></b-form-input>
        </div>
        <div
          v-if="
            form.jenis_pnbp_perubahan.includes(
              'Pipa Selain Air Bersih / Air Baku',
            )
          "
          class="col-md-6 mb-3"
        >
          <label for="panjang_nonkonservasi_pipa_lain">
            Panjang Pipa Selain Air Bersih (di luar Kws. Konservasi) (km)
          </label>
          <b-form-input
            id="panjang_nonkonservasi_pipa_lain"
            v-model="form.panjang_nonkonservasi_pipa_lain_perubahan"
            name="Panjang Pipa Selain Air Bersih (Luar Kawasan)"
            type="number"
            style="opacity: 0.7"
            disabled
          ></b-form-input>
        </div>
        <div class="col-12 mb-3">
          <label for="rencana_detail_kegiatan">Rencana Detail Kegiatan</label>
          <div style="opacity: 0.7">
            <ckeditor
              :editor="wygEditor"
              v-model="form.rencana_detail_kegiatan_perubahan"
              disabled
            ></ckeditor>
          </div>
        </div>
      </div>
    </b-form> -->

    <div class="mb-4">
      <legend>
        <strong>Hasil Analisis</strong>
      </legend>
      <div>
        <ckeditor
          :editor="wygEditor"
          v-model="formBaPentek.hasil_verifikasi_teknis"
        ></ckeditor>
        <span class="text-danger" v-if="errors.has('Hasil Analisis')">
          {{ errors.first('Hasil Analisis') }}
        </span>
      </div>
    </div>

    <div class="mb-4">
      <legend>
        <strong>Tanda Tangan</strong>
      </legend>
      <div class="row mb-2">
        <div class="col-lg-4">
          <label for="ttd_ba_vertek_1">Direktur</label>
          <v-select
            id="ttd_ba_vertek_1"
            v-model="formBaPentek.ttd_ba_vertek_1"
            :reduce="(data) => data.id_user"
            label="nama_lengkap"
            :options="ttdDirektur"
            name="TTD Direktur"
            v-validate="'required'"
          />
          <span class="text-danger" v-if="errors.has('TTD Direktur')">
            {{ errors.first('TTD Direktur') }}
          </span>
        </div>
        <div class="col-lg-4">
          <label for="ttd_ba_vertek_2">Ketua Tim</label>
          <v-select
            id="ttd_ba_vertek_2"
            v-model="formBaPentek.ttd_ba_vertek_2"
            :reduce="(data) => data.id_user"
            label="nama_lengkap"
            :options="ttdKetuaTim"
            name="TTD Ketua Tim"
            v-validate="'required'"
          />
          <span class="text-danger" v-if="errors.has('TTD Ketua Tim')">
            {{ errors.first('TTD Ketua Tim') }}
          </span>
        </div>
        <div class="col-lg-4">
          <label for="ttd_ba_vertek_4">Pimpinan Rapat</label>
          <v-select
            id="ttd_ba_vertek_4"
            v-model="formBaPentek.ttd_ba_vertek_4"
            :reduce="(data) => data.id_user"
            label="nama_lengkap"
            :options="ttdPimpinanRapat"
            name="TTD Pimpinan Rapat"
            v-validate="'required'"
          />
          <span class="text-danger" v-if="errors.has('TTD Pimpinan Rapat')">
            {{ errors.first('TTD Pimpinan Rapat') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import vSelect from 'vue-select'
import axios from 'axios'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Swal from 'sweetalert2'

export default {
  components: { vSelect },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      // form: {
      //   provinsi_perubahan: null,
      //   kabupaten_perubahan: null,
      //   kecamatan_perubahan: null,
      //   nama_perairan_perubahan: null,
      //   garis_pantai_perubahan: null,
      //   jenis_pnbp_perubahan: [],
      //   luas_perubahan: null,
      //   panjang_konservasi_kabel_perubahan: null,
      //   panjang_nonkonservasi_kabel_perubahan: null,
      //   panjang_konservasi_pipa_air_perubahan: null,
      //   panjang_nonkonservasi_pipa_air_perubahan: null,
      //   panjang_konservasi_pipa_lain_perubahan: null,
      //   panjang_nonkonservasi_pipa_lain_perubahan: null,
      //   kedalaman_perubahan: null,
      //   rencana_detail_kegiatan_perubahan: null,
      // },
      formBaPentek: {
        hasil_verifikasi_teknis: null,
        ttd_ba_vertek_1: null,
        ttd_ba_vertek_2: null,
        ttd_ba_vertek_4: null,
        pimpinan_rapat: 'ttd_ba_vertek_4',
      },
      file_peta_pv: null,
      file_peta: null,
      dataPermohonan: {},
      formKoordinat: {
        nama_titik: '',
        bujur: '',
        lintang: '',
      },
      editKoordinatId: null,
      formImportKoordinat: {
        file: null,
      },
      fields: ['no', 'nama_titik', 'bujur', 'lintang', 'aksi'],
      dataKordinat: [],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'name',
      sortDesc: false,
      wygEditor: ClassicEditor,
      dataProvinsi: [],
      selectedProvinsi: null,
      dataKabupaten: [],
      selectedKabupaten: null,
      dataKecamatan: [],
      dataJenisDokumenPermohonan: [],
      ttdDirektur: [],
      ttdKetuaTim: [],
      ttdPimpinanRapat: [],
    }
  },
  methods: {
    async nextForm() {
      return await this.submitForm()
    },

    async loadDataPermohonan() {
      const id = this.$route.query.id_pemutakhiran
      if (!id) {
        this.$router.push('/app/perubahan')
        return
      }

      const res = await axios.get(
        `${this.baseapi}api/habis_masa_berlaku/${id}`,
        this.getApiOption(),
      )
      const resPemutakhiran = res.data.data

      // const jenisPermohonan = resPemutakhiran.jenis_permohonan
      // const nomorIzin = resPemutakhiran.nomor_izin_terbit
      // const api =
      //   jenisPermohonan === 'Berusaha'
      //     ? `${this.baseapi}api/permohonan/dataTable?filter=nomor_oss,=,${nomorIzin}`
      //     : `${this.baseapi}api/permohonan_nonberusaha/dataTable?filter=nomor_kkp,=,${nomorIzin}`
      // const res2 = await axios.get(api, this.getApiOption())
      // const resData2 = res2.data.data[0]
      // this.dataPermohonan = resData2

      // prettier-ignore
      // this.form = {
      //   provinsi_perubahan: resPemutakhiran.provinsi_perubahan || resData2.provinsi,
      //   kabupaten_perubahan: resPemutakhiran.kabupaten_perubahan || resData2.kabupaten,
      //   kecamatan_perubahan: resPemutakhiran.kecamatan_perubahan || resData2.kecamatan,
      //   nama_perairan_perubahan: resPemutakhiran.nama_perairan_perubahan || resData2.nama_perairan,
      //   garis_pantai_perubahan: resPemutakhiran.garis_pantai_perubahan || resData2.garis_pantai,
      //   jenis_pnbp_perubahan: resPemutakhiran.jenis_pnbp_perubahan || resData2.jenis_pnbp,
      //   luas_perubahan: resPemutakhiran.luas_perubahan || resData2.luas,
      //   panjang_konservasi_kabel_perubahan: resPemutakhiran.panjang_konservasi_kabel_perubahan || resData2.panjang_konservasi_kabel,
      //   panjang_nonkonservasi_kabel_perubahan: resPemutakhiran.panjang_nonkonservasi_kabel_perubahan || resData2.panjang_nonkonservasi_kabel,
      //   panjang_konservasi_pipa_air_perubahan: resPemutakhiran.panjang_konservasi_pipa_air_perubahan || resData2.panjang_konservasi_pipa_air,
      //   panjang_nonkonservasi_pipa_air_perubahan: resPemutakhiran.panjang_nonkonservasi_pipa_air_perubahan || resData2.panjang_nonkonservasi_pipa_air,
      //   panjang_konservasi_pipa_lain_perubahan: resPemutakhiran.panjang_konservasi_pipa_lain_perubahan || resData2.panjang_konservasi_pipa_lain,
      //   panjang_nonkonservasi_pipa_lain_perubahan: resPemutakhiran.panjang_nonkonservasi_pipa_lain_perubahan || resData2.panjang_nonkonservasi_pipa_lain,
      //   kedalaman_perubahan: resPemutakhiran.kedalaman_perubahan || resData2.kedalaman,
      //   rencana_detail_kegiatan_perubahan: resPemutakhiran.rencana_detail_kegiatan_perubahan || resData2.rencana_detail_kegiatan,
      // }

      // prettier-ignore
      this.formBaPentek = {
        ...this.formBaPentek,
        hasil_verifikasi_teknis:resPemutakhiran.hasil_verifikasi_teknis || null,
        ttd_ba_vertek_1: resPemutakhiran.ttd_ba_vertek_1 || null,
        ttd_ba_vertek_2: resPemutakhiran.ttd_ba_vertek_2 || null,
        ttd_ba_vertek_4: resPemutakhiran.ttd_ba_vertek_4 || null,
      }
    },

    async submitForm() {
      this.$validator.errors.clear()
      // prettier-ignore
      {
        this.manualValidation(this.formBaPentek.hasil_verifikasi_teknis, 'Hasil Analisis')
      }
      await this.$validator.validateAll()
      if (this.$validator.errors.items.length) return false

      const id = this.$route.query.id_pemutakhiran
      try {
        this.$loading(true)

        const formData2 = new FormData()
        for (const k in this.formBaPentek) {
          if (this.formBaPentek[k]) formData2.append(k, this.formBaPentek[k])
        }

        await axios.post(
          `${this.baseapi}api/habis_masa_berlaku/setPentek/${id}`,
          formData2,
          this.getApiOption(),
        )

        await axios.post(
          `${this.baseapi}api/habis_masa_berlaku/${id}`,
          { status: 'Penyusunan Berita Acara Hasil Penilaian' },
          this.getApiOption(),
        )

        Swal.fire('Berhasil', 'Pemutakhiran berhasil disimpan', 'success')
        return true
      } catch (error) {
        Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
        return false
      } finally {
        this.$loading(false)
      }
    },

    async getProvinsi() {
      await axios
        .get(this.baseapi + 'api/provinsi?sort=id,ASC', this.getApiOption())
        .then((response) => {
          this.dataProvinsi = response.data.data
        })
    },

    async getKabupaten(id_provinsi) {
      await axios
        .get(
          this.baseapi +
            `api/kabupaten?sort=id,ASC&filter=id_provinsi,=,${id_provinsi}`,
          this.getApiOption(),
        )
        .then((response) => {
          this.dataKabupaten = response.data.data
        })
    },

    async getKecamatan(id_kabupaten) {
      await axios
        .get(
          this.baseapi +
            `api/kecamatan?sort=id,ASC&filter=id_kabupaten,=,${id_kabupaten}`,
          this.getApiOption(),
        )
        .then((response) => {
          this.dataKecamatan = response.data.data
        })
    },

    async getJenisDokumenPermohonan() {
      await axios
        .get(this.baseapi + 'api/jenis_permohonan', this.getApiOption())
        .then((response) => {
          this.dataJenisDokumenPermohonan = response.data.data
        })
    },

    async getTtd() {
      await axios
        .get(this.baseapi + 'api/tandatangan', this.getApiOption())
        .then((response) => {
          const resData = response.data.data
          this.ttdDirektur = resData.filter((d) => d.role === 'direktur')
          this.ttdKetuaTim = resData.filter((d) => d.role === 'ketua_tim')
          this.ttdPimpinanRapat = resData
        })
    },

    manualValidation(field, name) {
      if (!field) {
        this.$validator.errors.add({
          field: name,
          msg: `${name} wajib diisi`,
        })
        return false
      } else {
        return true
      }
    },

    manualRemoveError(name) {
      this.$validator.errors.remove(name)
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },
  },
  watch: {
    'form.provinsi_perubahan'(val) {
      const provinsi = this.dataProvinsi.find((d) => d.nama_provinsi === val)
      if (provinsi) this.getKabupaten(provinsi.id)
    },
    'form.kabupaten_perubahan'(val) {
      const kabupaten = this.dataKabupaten.find((d) => d.nama_kabupaten === val)
      if (kabupaten) this.getKecamatan(kabupaten.id)
    },
    'formBaPentek.hasil_verifikasi_teknis'() {
      this.manualRemoveError('Hasil Analisis')
    },
  },
  mounted() {
    this.getProvinsi()
    this.getJenisDokumenPermohonan()
    this.getTtd()
    this.loadDataPermohonan()

    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
}
</script>
